import { render } from "./messagingPlatforms.vue?vue&type=template&id=8e52e0c4&scoped=true"
import script from "./messagingPlatforms.vue?vue&type=script&lang=js"
export * from "./messagingPlatforms.vue?vue&type=script&lang=js"

import "./messagingPlatforms.vue?vue&type=style&index=0&id=8e52e0c4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e52e0c4"]])

export default __exports__